import { TaskResponse } from "@9amhealth/openapi";
import { RateCoachingCallState } from "src/state/RateCoachingCallCubit/RateCoachingCallCubit";
import { CoachRatingScreen } from "./CoachRatingScreen";

export const getCoachRatingScreen = ({
  isLoading,
  task
}: RateCoachingCallState): CoachRatingScreen => {
  if (isLoading) {
    return CoachRatingScreen.LOADING;
  }
  if (!task) {
    return CoachRatingScreen.ERROR;
  }
  const { status } = task;
  if (status === TaskResponse.status.COMPLETED) {
    return CoachRatingScreen.ALREADY_RATED;
  }
  if (status === TaskResponse.status.AVAILABLE) {
    return CoachRatingScreen.RATE_NOW;
  }
  if (status === TaskResponse.status.SKIPPED) {
    return CoachRatingScreen.EXPIRED;
  }

  return CoachRatingScreen.ERROR;
};
